import moment from "moment";
import { convertFloatToMoney } from "../../modules/helpers";

export function arrayRemove(arr, value) {
    return arr.filter(function(ele){
        return ele != value;
    });
}

export function R$(amount) {
    return `R$ ${convertFloatToMoney(amount)}`;
}

export function dateDiff(date, format='DD/MM/YYYY', diffType='day') {
    const actualDate = moment(date, format);
    const actualMomentoDate = moment(moment().format(format), format)
    const diff = actualDate.diff(actualMomentoDate, diffType);
    return diff;
}


// WEBPACK FOOTER //
// ./src/loteria/utils/utils.js